export const lightPalette = {
  mode: 'light',
  primary: {
    main: '#2AB63F',
    light: '#5ce06b',
    dark: '#1a8a2d',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#556cd6',
    light: '#7b8be3',
    dark: '#3d4db3',
    contrastText: '#ffffff',
  },
  error: {
    main: '#ec536c',
    light: '#f07b8e',
    dark: '#c43a52',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f1b44c',
    light: '#f5c878',
    dark: '#d89f3a',
    contrastText: '#212529',
  },
  info: {
    main: '#50a5f1',
    light: '#7abdf5',
    dark: '#3a8fd8',
    contrastText: '#ffffff',
  },
  success: {
    main: '#2AB63F',
    light: '#5ce06b',
    dark: '#1a8a2d',
    contrastText: '#ffffff',
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  text: {
    primary: '#212529',
    secondary: '#74788d',
    disabled: '#9e9e9e',
  },
  background: {
    default: '#f5f6f8',
    paper: '#ffffff',
  },
  divider: '#e9ecef',
  action: {
    active: '#2AB63F',
    hover: 'rgba(42, 182, 63, 0.08)',
    selected: 'rgba(42, 182, 63, 0.14)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};

export const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#2AB63F',
    light: '#5ce06b',
    dark: '#1a8a2d',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#7b8be3',
    light: '#a0adef',
    dark: '#556cd6',
    contrastText: '#ffffff',
  },
  error: {
    main: '#f07b8e',
    light: '#f5a0ae',
    dark: '#ec536c',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f5c878',
    light: '#f9dda5',
    dark: '#f1b44c',
    contrastText: '#212529',
  },
  info: {
    main: '#7abdf5',
    light: '#a5d3f9',
    dark: '#50a5f1',
    contrastText: '#ffffff',
  },
  success: {
    main: '#2AB63F',
    light: '#5ce06b',
    dark: '#1a8a2d',
    contrastText: '#ffffff',
  },
  grey: {
    50: '#212121',
    100: '#303030',
    200: '#424242',
    300: '#616161',
    400: '#757575',
    500: '#9e9e9e',
    600: '#bdbdbd',
    700: '#e0e0e0',
    800: '#eeeeee',
    900: '#f5f5f5',
  },
  text: {
    primary: '#e9ecef',
    secondary: '#a6b0cf',
    disabled: '#757575',
  },
  background: {
    default: '#222736',
    paper: '#2a3042',
  },
  divider: '#32394e',
  action: {
    active: '#2AB63F',
    hover: 'rgba(42, 182, 63, 0.15)',
    selected: 'rgba(42, 182, 63, 0.25)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
};

const palette = { light: lightPalette, dark: darkPalette };

export default palette;
